import { WorkflowFieldType } from '~/enums/WorkflowFieldType';
import { WellKnownFields } from '~/features/ticket/types/well-known-fields';
import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type WellKnownFieldResponseValue =
  | { value: string | number }
  | {
      default_value: string;
      resource_id: string;
    }
  | null;

interface WellKnownFieldResponse {
  name: string;
  type: WorkflowFieldType;
  value: WellKnownFieldResponseValue;
}

interface WellKnownFieldsResponse {
  fields: {
    [key: string]: {
      name: string;
      type: WorkflowFieldType;
      value: WellKnownFieldResponseValue;
    };
  };
}

const getWellKnownFieldValue = (
  field: WellKnownFieldResponse,
): string | number | null => {
  if (field.value === null) {
    return null;
  }

  if (
    field.type === WorkflowFieldType.Reference &&
    'default_value' in field.value
  ) {
    return field.value.default_value;
  }

  if ('value' in field.value) {
    return field.value.value;
  }

  return null;
};

const mapResponse = (response: WellKnownFieldsResponse): WellKnownFields => {
  const fields = Object.entries(response.fields).reduce(
    (allFields, [key, field]) => {
      allFields[key] = {
        name: field.name,
        type: field.type,
        value: getWellKnownFieldValue(field),
      };

      return allFields;
    },
    {} as WellKnownFields['fields'],
  );

  return { fields };
};

export const getTicketWellKnownFields = async (
  ticketId: Uuid,
): Promise<WellKnownFields> => {
  const response: WellKnownFieldsResponse = await everest.get(
    `/tickets/${ticketId}/well-known-fields`,
  );
  return mapResponse(response);
};
